import {
  FlexibleBlockBrickSubmenu,
  FlexibleBlockProps,
  FlexibleBlockTemplateSubmenu,
  PortalTextType,
} from '@nx-frontend/shared/types';
import { getWrapperProps } from '@nx-frontend/shared/utils';
import { brickCommon } from './common';

export const getSubmenuBlockTemplate = (): FlexibleBlockProps<FlexibleBlockTemplateSubmenu>[] => {
  const brickSubmenu: FlexibleBlockBrickSubmenu = {
    ...brickCommon,
    brickName: 'Items',
    brickType: 'submenu',
    relatedMenuItemId: '',
    showAddItem: false,
    theme: {
      text: {
        main: PortalTextType.SURFACE,
      },
    },
    items: [],
    className: ['text-base'],
  };

  return [
    {
      title: 'Content',
      template: {
        type: 'submenu',
        view: 'basic',
      },
      bricks: [{ ...brickSubmenu, index: 0 }],
      wrapper: getWrapperProps('blank'),
      className: ['text-lg', 'text-left'],
    },
  ];
};
